import React from 'react';
import { Field, Form } from 'react-final-form';

import Button from '../../shared/Button';
import Input from '../../shared/Input';

import '../../../styles/shared/form.scss';

const ProcedureEquipmentListForm = (props) => {
  const {
    mode = 'create',
    initialValues,
    buttonText,
    onSubmit,
    loading,
    onClose,
  } = props;

  const { name } = initialValues || {};

  const validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = 'Required';
    }

    return errors;
  };

  return (
    <div className='form__container'>
      <Form
        onSubmit={(formObj) => onSubmit(formObj, mode)}
        validate={validate}
        initialValues={{
          ...initialValues,
          procedures: initialValues?.procedures || []
        }}
        subscription={{ pristine: true, invalid: true, values: true }}
        mutators={{
          resetHospitals: (args, state, utils) => {
            utils.changeValue(state, 'hospitals', () => [])
          },
          resetProcedures: (args, state, utils) => {
            utils.changeValue(state, 'procedures', () => [])
          },
        }}
      >
        {
          ({ handleSubmit, submitting, invalid, pristine }) => (
            <form onSubmit={handleSubmit} className='form__body'>
              <div className='form__subtitle'>
                { name ? name : 'Add Equipment List' }
              </div>
              { mode === 'update' && (
                <Field name='active'>
                  {({ input, meta }) => (
                    <Input
                      type='switch'
                      name={input.name}
                      value={input.value}
                      onChange={input.onChange}
                      placeholder='Status'
                    />
                  )}
                </Field>
              )}

              <div className='m-b-sm'>
                <div className='field__title'>Name</div>
                <Field name='name'>
                  {({ input, meta }) => (
                    <Input
                      name={input.name}
                      value={input.value}
                      placeholder='Name'
                      type='text'
                      onChange={input.onChange}
                    />
                  )}
                </Field>
              </div>

              <div className='m-b-sm'>
                <div className='field__title'>Subtitle</div>
                <Field name='subtitle'>
                  {({ input, meta }) => (
                    <Input
                      name={input.name}
                      value={input.value}
                      placeholder=''
                      type='text'
                      onChange={input.onChange}
                    />
                  )}
                </Field>
              </div>

              { mode === 'update' && (
                <>
                  {/*<div className='m-b-sm'>*/}
                  {/*  <div className='field__title'>Equipment List Notes</div>*/}
                  {/*  <Field name='description'>*/}
                  {/*    {({ input, meta }) => (*/}
                  {/*      <Input*/}
                  {/*        name={input.name}*/}
                  {/*        value={input.value}*/}
                  {/*        placeholder=''*/}
                  {/*        type='text'*/}
                  {/*        multiline*/}
                  {/*        onChange={input.onChange}*/}
                  {/*      />*/}
                  {/*    )}*/}
                  {/*  </Field>*/}
                  {/*</div>*/}
                </>
              )}

              <div className='form__actions'>
                <Button
                  type='submit'
                  text={buttonText || 'Save Changes'}
                  disabled={invalid || loading || pristine}
                  loading={loading}
                  onClick={handleSubmit}
                />
                {mode === 'create' && (
                  <Button
                    type='cancel'
                    onClick={onClose}
                  />
                )}
              </div>
            </form>
          )}
      </Form>
    </div>
  );
};

export default ProcedureEquipmentListForm;
